var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Select from '@/common/components/Select/index.vue';
var FormSelect = /** @class */ (function (_super) {
    __extends(FormSelect, _super);
    function FormSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.loading = false;
        _this.selectValue = _this.defaultName || _this.$attrs.value || '';
        _this.isInit = false; // 是否初始化赋值过;
        return _this;
    }
    FormSelect.prototype.WatchSelectValue = function (val) {
        if (val !== this.defaultName) {
            this.$emit('input', val);
        }
    };
    FormSelect.prototype.WatchValue = function (val) {
        if (!this.defaultName) {
            this.selectValue = val;
        }
        if (this.selectValue && !val) {
            this.selectValue = val;
            return;
        }
    };
    FormSelect.prototype.WatchDefaultName = function (val) {
        if (this.isInit || !val)
            return;
        this.selectValue = val;
        this.isInit = true;
    };
    FormSelect.prototype.focus = function () {
        this.$refs.formSelect.focus();
    };
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], FormSelect.prototype, "label", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], FormSelect.prototype, "prop", void 0);
    __decorate([
        Prop({
            type: Object,
        })
    ], FormSelect.prototype, "rules", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], FormSelect.prototype, "required", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], FormSelect.prototype, "defaultName", void 0);
    __decorate([
        Watch('selectValue')
    ], FormSelect.prototype, "WatchSelectValue", null);
    __decorate([
        Watch('$attrs.value')
    ], FormSelect.prototype, "WatchValue", null);
    __decorate([
        Watch('defaultName')
    ], FormSelect.prototype, "WatchDefaultName", null);
    FormSelect = __decorate([
        Component({
            components: { Select: Select },
            inheritAttrs: false,
        })
    ], FormSelect);
    return FormSelect;
}(Vue));
export default FormSelect;
